import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface MaintenanceState {
  enabled: boolean;
  message: string;
  loading: boolean;
}

export function useMaintenanceMode() {
  const [state, setState] = useState<MaintenanceState>({
    enabled: false,
    message: '',
    loading: true,
  });

  useEffect(() => {
    async function fetchMaintenanceMode() {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('value')
          .eq('key', 'maintenance_mode')
          .single();

        if (error) {
          console.error('Error fetching maintenance mode:', error);
          setState({ enabled: false, message: '', loading: false });
          return;
        }

        const value = data?.value as { enabled?: boolean; message?: string } | null;
        setState({
          enabled: value?.enabled || false,
          message: value?.message || '',
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching maintenance mode:', error);
        setState({ enabled: false, message: '', loading: false });
      }
    }

    fetchMaintenanceMode();
  }, []);

  return state;
}
